import { render, staticRenderFns } from "./CustomerListTop.vue?vue&type=template&id=3b01f8ae&"
import script from "./CustomerListTop.vue?vue&type=script&lang=js&"
export * from "./CustomerListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports